module.exports = require('react');